/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useReducer,
  useRef,
  useEffect,
  useCallback,
  ReducerState,
  Dispatch,
  Reducer,
} from 'react'

export const useSafeReducer = <R extends Reducer<any, any>, I>(
  reducer: R,
  initializerArg: I & ReducerState<R>
): [ReducerState<R>, Dispatch<Parameters<R>[1]>] => {
  const [state, dispatch] = useReducer(reducer, initializerArg)
  const mounted = useRef<boolean>(false)

  useEffect(() => {
    mounted.current = true

    return () => {
      mounted.current = false
    }
  }, [])

  const safeDispatch: Dispatch<Parameters<R>[1]> = useCallback(args => {
    if (mounted.current) {
      dispatch(args)
    }
  }, [])

  return [state, safeDispatch]
}
